import React from 'react';
import axios from 'axios';
import useSWR from 'swr';
import { message } from 'antd';

export interface RequestPartSalesData {
    key: React.Key;
    status: string;
    date_request: string;
    so_no: string;
    pr_no: string;
    sales: string;
    warehouse: string;
}

const fetcher = (url: string) => axios.get<RequestPartSalesData[]>(url).then(res => res.data);

const withRequestPartSalesLogic = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
    return (props: P) => {
        const { data, error, isLoading } = useSWR<RequestPartSalesData[]>(
            `${process.env.REACT_APP_BACKEND_URL}/api/request-part-sales`,
            fetcher
        );

        if (error) {
            console.error('Failed to fetch request part sales data:', error);
            message.error('Gagal memuat data Request Part Sales.');
        }

        return (
            <WrappedComponent
                {...props}
                dataSource={data || []}
                isLoading={isLoading}
            />
        );
    };
};

export default withRequestPartSalesLogic;